import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-payment-failed-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './payment-failed.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentFailedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<PaymentFailedTemplateData>;
}

export type PaymentFailedTemplateData = {
  title: string;
  p1: string;
  amount_html: string;
  company_name_html: string;
  next_attempt_html: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const PaymentFailedTemplateMocks: PaymentFailedTemplateData[] = [
  {
    title: 'Payment failed',
    p1: 'The payment for your Recruitee subscription has failed.',
    amount_html: 'Amount: <b>399 EUR</b>',
    company_name_html: 'Company: <b>ACME</b>',
    next_attempt_html: 'We will attempt to charge your card again on <strong>21 Aug 2019.</strong>',
    button_link: 'http://recruitee.com',
    button_text: 'Update billing information now',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
